/**
 * UX-036: Recently Viewed Properties Utility
 * Tracks and retrieves recently viewed properties using localStorage
 */

const RECENTLY_VIEWED_KEY = 'afriqahome_recently_viewed';
const MAX_RECENT = 10;

export interface RecentlyViewedItem {
  id: string;
  title: string;
  image: string;
  price: number;
  currency: string;
  location: string;
  viewedAt: string;
}

export const addToRecentlyViewed = (property: {
  id: string;
  address?: string;
  title?: string;
  image?: string;
  images?: string[];
  price: number;
  currency?: string;
  city?: string;
  location?: string;
}) => {
  try {
    const saved = localStorage.getItem(RECENTLY_VIEWED_KEY);
    const recent: RecentlyViewedItem[] = saved ? JSON.parse(saved) : [];

    // Remove if already exists
    const filtered = recent.filter(p => p.id !== property.id);

    // Add to front
    const updated = [
      {
        id: property.id,
        title: property.address || property.title || 'Property',
        image: property.images?.[0] || property.image || '',
        price: property.price,
        currency: property.currency || 'KES',
        location: property.city || property.location || '',
        viewedAt: new Date().toISOString()
      },
      ...filtered
    ].slice(0, MAX_RECENT);

    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
  } catch (e) {
    console.error('Failed to save recently viewed:', e);
  }
};

export const getRecentlyViewed = (): RecentlyViewedItem[] => {
  try {
    const saved = localStorage.getItem(RECENTLY_VIEWED_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    console.error('Failed to get recently viewed:', e);
    return [];
  }
};

export const clearRecentlyViewed = () => {
  localStorage.removeItem(RECENTLY_VIEWED_KEY);
};
